import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "banner",
  legacy: {
    data: "banner",
    count: "count",
    fetch: "fetchBanners",
    create: "createOneBanner",
    update: "updateBanner",
    remove: "deleteBanner",
    updateState: "updateBannerState",
  },
});

export const BannerProvider = Provider;
export const useBannerContext = useValue;
